import { Capacitor, PluginListenerHandle, registerPlugin } from '@capacitor/core'
import type { NavigateFunction, To } from 'react-router-dom'

export interface SwipeBackProgressEvent {
  progress: number
}

export interface SwipeBackPlugin {
  enable(): Promise<void>
  disable(): Promise<void>
  pushSnapshot(): Promise<void>
  popSnapshot(): Promise<void>
  clearSnapshots(): Promise<void>
  addListener(
    eventName: 'swipeBackProgress',
    listener: (event: SwipeBackProgressEvent) => void,
  ): Promise<PluginListenerHandle>
  addListener(eventName: 'swipeBackCommit', listener: () => void): Promise<PluginListenerHandle>
  addListener(eventName: 'swipeBackCancel', listener: () => void): Promise<PluginListenerHandle>
}

export const isIOS = () => Capacitor.getPlatform() === 'ios'

export const SwipeBack = registerPlugin<SwipeBackPlugin>('SwipeBack')

export const pushAndNavigate = (navigate: NavigateFunction, to: To) => {
  if (isIOS()) void SwipeBack.pushSnapshot()
  navigate(to)
}

export const pushAndOpen = (open: () => void) => {
  if (isIOS()) void SwipeBack.pushSnapshot()
  open()
}

// Wrap a back-action (back-arrow tap, drawer close) so the snapshot
// stack stays aligned with React's navigation state when the gesture
// path isn't used.
export const popAndBack = (action: () => void) => {
  if (isIOS()) void SwipeBack.popSnapshot()
  action()
}
